import _deviceInfo from './deviceInfo';
export const deviceInfo = _deviceInfo;
export default deviceInfo;
